import AgentLayout from "../../../AdminPortal/Layouts/Layout";
import {
  Row,
  Col,
  Typography,
  Modal,
  Space,
  Select,
  Form,
  Divider,
  Button,
  Spin,
  message,
  Carousel,
} from "antd";
import NoImageAvailable from "../../../../assets/reqest.png";
import axios from "axios";
import useSWR from "swr";
import { colors } from "../../../AdminPortal/utils/colors";
import ItemCard from "../../components/Card/ItemCard";
import { useContext, useState, useRef } from "react";
import UserContext from "../../../Contexts/UserContext";
import { isMobile } from "react-device-detect";
import { CartContext } from "../../../Contexts/CartContext";
import PointsDisplay from "../../../AdminPortal/components/AgentPoints/AgentPoints";

import { BASE_URL } from '../../../Constants/EnvironmentVariableProvider';
import {
  FILTER_DATA_FAV_API,
  ADD_FAVORITE_API,
  GET_REWARD_BYID,
} from '../../../API/paths';
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Text, Title } = Typography;
// const { Option } = Select;

const AgentFavorite = () => {
  const { addToCart } = useContext(CartContext);
  const [modalOpen, setModalopen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [singleReward, setSingleReward] = useState(null);
  const [variant_form] = Form.useForm();
  const { auth } = useContext(UserContext);
  const previousDataRef = useRef(null);
  const fav_rewards_api =
    BASE_URL + FILTER_DATA_FAV_API + auth?.result?.ACAG_KeyID;
  const {
    data: rewards,
    isLoading,
    mutate: mutateReward,
  } = useSWR({
    url: fav_rewards_api,
  }, {
    keepPreviousData: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    onSuccess: (data) => {
      previousDataRef.current = data;
    }
  });
  
  // Show loading indicators only on first load, not revalidation
  const loading = isLoading && !previousDataRef.current;
  
  // Use previous data when available to prevent flashing "no favorites" state
  const displayData = rewards || previousDataRef.current;

  const ModalContoller = async (
    rewardId,
    quantity,
    Agent_Redeemed_Quantity,
    ARLR_Redeemable_Quantity
  ) => {
    if (quantity < 1) {
      message.error("The reward item is no longer available to redeem");
      return;
    }
    if (Agent_Redeemed_Quantity >= ARLR_Redeemable_Quantity) {
      message.error("You have already redeemed the available quantity.");
      return;
    }
    try {
      setModalopen(true);
      setModalLoading(true);
      const response = await axios.get(`${GET_REWARD_BYID}?Id=${rewardId}`);
      const result = response?.data?.result;
      result?.tbl_ARRV_Reward_Variants?.forEach((item, index) => {
        if (index === 0) {
          item["status"] = true;
        } else {
          item["status"] = false;
        }
      });
      variant_form.setFieldsValue({
        variant_id:
          result?.tbl_ARRV_Reward_Variants[0]?.ARRV_Reward_Variant_KeyID,
      });
      setModalLoading(false);
      setSingleReward(result ? result : null);
    } catch (e) {
      setModalLoading(false);
      console.log(e);
    }
  };
  const handleVariantChange = (values) => {
    if (!values) {
      return;
    }
    let dataCopy = { ...singleReward };
    const index = dataCopy?.tbl_ARRV_Reward_Variants?.findIndex(
      (item) => item?.ARRV_Reward_Variant_KeyID === values
    );
    dataCopy?.tbl_ARRV_Reward_Variants?.forEach((item, item_index) => {
      if (item_index === index) {
        item.status = true;
      } else {
        item.status = false;
      }
    });
    setSingleReward(dataCopy);
  };
  
  const addFav = async (reward_id, fav_status) => {
    if (!reward_id) return;
    if (!rewards || !rewards.result) return;
    
    if (fav_status) {
      // Show optimistic message immediately
      message.success("Remove from favorites");
      
      // First update the UI to show the heart toggle
      const updatedItems = rewards.result.map(item => {
        if (item.ARFA_Reward_ARLR_KeyID === reward_id) {
          return {
            ...item,
            tbl_ARLR_Rewards: {
              ...item.tbl_ARLR_Rewards,
              IsFavorite: false
            }
          };
        }
        return item;
      });
      
      // Update UI with unfavorited state but still showing the item
      mutateReward({ ...rewards, result: updatedItems }, false);
      
      setTimeout(() => {
        const filteredResults = rewards.result.filter(
          item => item.ARFA_Reward_ARLR_KeyID !== reward_id
        );
        mutateReward({ ...rewards, result: filteredResults }, false);
      }, 300);
    } else {
      // For adding to favorites (this is likely happening on the shop page, not here)
      message.success("Reward has been added to favorites");
    }
    

    const fav_data = {
      ARFA_Agent_ACAG_KeyID: auth?.result?.ACAG_KeyID,
      ARFA_Reward_ARLR_KeyID: reward_id,
      ARFA_zalt_Altered_Type: !fav_status,
    };
  
    try {
      await axios.post(ADD_FAVORITE_API, fav_data);
      // Silently revalidate in the background
      mutateReward();
    } catch (e) {
      console.log(e);
      message.error("There was an error updating your favorites");
      // Revalidate to fix any state issues
      mutateReward();
    }
  };

  let imageSrc = singleReward?.ARLR_Images_Path ? [...singleReward.ARLR_Images_Path] : [];
  if (singleReward?.ARLR_Image_Path) {
    imageSrc.unshift(singleReward?.ARLR_Image_Path);
  }
  imageSrc = (imageSrc?.length ?? 0) === 0 ? [NoImageAvailable] : imageSrc;

  const handleCancelClick = () => {
    imageSrc = [NoImageAvailable];
    setModalopen(false)
  }

  return (
    <AgentLayout>
      <div
        style={{
          paddingLeft: isMobile ? 14 : 60,
          paddingRight: isMobile ? 14 : 60,
          marginTop: 28,
          marginBottom: 20,
        }}
      >
        <div style={{ marginBottom: 10 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Space direction="vertical" size={0}>
              {!isMobile && (
                <Text style={{ color: colors.black }}>
                  Home /
                  <span style={{ color: colors.grey200 }}> My Favorite</span>
                </Text>
              )}
              <Title level={5} style={{ color: colors.black }}>
                My Favorites
              </Title>
            </Space>
            <PointsDisplay points={JSON.parse(localStorage.getItem("totalPoints") || "0")} />
          </div>
        </div>
        <Divider />
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
        >
          {loading ? (
            [...Array(12)].map((_, index) => (
              <Col
                key={`skeleton-${index}`}
                className="gutter-row"
                xs={24}
                sm={12}
                md={8}
                lg={6}
                xl={6}
                xxl={4}
              >
                <ItemCard
                  src=""
                  addFav={() => {}}
                  productName="loading..."
                  category_title="      "
                  norm_points={" "}
                  index={index}
                />
              </Col>
            ))
          ) : displayData?.result?.length > 0 ? (
            displayData.result.map((item, index) => (
              <Col
                key={"agent-favorite-columns" + index}
                className="gutter-row"
                xs={24}
                sm={12}
                md={8}
                lg={6}
                xl={6}
                xxl={4}
              >
                <ItemCard
                  key={"agent-favorite-itemcard" + index}
                  rewardId={item?.ARFA_Reward_ARLR_KeyID}
                  addFav={addFav}
                  quantity={item?.tbl_ARLR_Rewards?.ARLR_Quantity}
                  category_title={
                    item?.tbl_ARLR_Rewards?.tbl_ARLC_Categories?.ARLC_Title
                  }
                  favorite={item?.tbl_ARLR_Rewards?.IsFavorite}
                  productName={item?.tbl_ARLR_Rewards?.ARLR_Title}
                  src={item?.tbl_ARLR_Rewards?.ARLR_Image_Path}
                  loading={false}
                  index={index}
                  norm_points={item?.tbl_ARLR_Rewards?.ARLR_Norm_Points}
                  ModalContoller={ModalContoller}
                  Agent_Redeemed_Quantity={
                    item?.tbl_ARLR_Rewards?.Agent_Redeemed_Quantity
                  }
                  ARLR_Redeemable_Quantity={
                    item?.tbl_ARLR_Rewards?.ARLR_Redeemable_Quantity
                  }
                />
              </Col>
            ))
          ) : (
            <Col span={24} style={{ textAlign: 'center', padding: '40px 0' }}>
              <Text style={{ fontSize: 16, color: colors.grey500 }}>
                No favorites found. Add items to your favorites from the shop!
              </Text>
            </Col>
          )}
        </Row>
      </div>
      <Modal
        open={modalOpen}
        footer={null}
        width="80vw"
        onCancel={handleCancelClick}
      >
        <Spin spinning={modalLoading}>
          <div style={{ backgroundColor: colors.bgGrey }}>
            <Row align="middle">
              <Col
                span={isMobile ? 24 : 12}
                style={{ backgroundColor: colors.white }}
              >
                {modalLoading ? null :
                  <Carousel 
                  arrows 
                  prevArrow={<LeftOutlined />}
                  nextArrow={<RightOutlined />}
                  style={{
                    height: isMobile ? 350 : 580,
                    width: "100%",
                    backgroundColor: "rgb(246, 248, 251)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: 'center'
                  }}>
                    {imageSrc.map((item) => (
                      <div key={item}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgb(246, 248, 251)" }}>
                          <img style={{ height: 350, width: 280, objectFit: "contain" }} src={item} alt="link" />
                        </div>
                      </div>
                    ))
                    }
                  </Carousel>}
              </Col>
              <Col span={isMobile ? 24 : 12}>
                <div style={{ padding: "0 24px" }}>
                  <Space
                    direction="vertical"
                    style={{ width: "100%", paddingTop: "60px" }}>
                    <Text
                      style={{
                        color: colors.black,
                        fontSize: 18,
                        fontWeight: 500,
                      }}
                    >
                      {singleReward?.ARLR_Title}
                    </Text>
                    <Text>
                      <pre
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          fontFamily: "inherit",
                          maxHeight: "300px",
                          overflowY: "auto",
                        }}
                      >
                        {singleReward?.ARLR_Description}
                      </pre>
                    </Text>
                    <Divider style={{ marginTop: 5 }} />
                    <Form
                      form={variant_form}
                      layout="vertical"
                      style={{ marginTop: -10 }}
                    >
                      {singleReward?.tbl_ARRV_Reward_Variants?.length < 1 ||
                        !singleReward?.tbl_ARRV_Reward_Variants ? (
                        ""
                      ) : (
                        <Form.Item
                          label="Select Variant"
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="variant_id"
                        >
                          <Select
                            style={{ width: "100%" }}
                            onChange={handleVariantChange}
                            disabled={
                              singleReward?.tbl_ARRV_Reward_Variants?.length <
                              1 || !singleReward?.tbl_ARRV_Reward_Variants
                            }
                          >
                            {singleReward?.tbl_ARRV_Reward_Variants?.map(
                              (item) => (
                                <Option
                                  key={"agent-favorite-options" + item}
                                  value={item?.ARRV_Reward_Variant_KeyID}
                                >
                                  {item?.ARRV_Title}
                                </Option>
                              )
                            )}
                          </Select>
                        </Form.Item>
                      )}
                    </Form>
                    <Divider style={{ marginTop: -10 }} />
                    <Text
                      style={{
                        float: "right",
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      Total Reward Points
                    </Text>
                    <Text
                      style={{
                        float: "right",
                        fontWeight: 600,
                        fontSize: 16,
                        color: colors.black,
                      }}
                    >
                      {singleReward?.ARLR_Norm_Points}
                    </Text>
                    <Button
                      onClick={() => addToCart(singleReward, setModalopen)}
                      type="primary"
                      disabled={singleReward?.ARLR_Quantity < 1}
                      style={{ width: "100%", marginTop: 10 }}
                    >
                      Add to cart
                    </Button>
                    <Button
                      type="text"
                      onClick={handleCancelClick}
                      style={{
                        width: "100%",
                        color: colors.black,
                        background: colors.white,
                        marginBottom: 10,
                      }}
                    >
                      Cancel
                    </Button>
                  </Space>
                </div>
              </Col>
            </Row>
          </div>
        </Spin>
      </Modal>
    </AgentLayout>
  );
};
export default AgentFavorite;